<template>
  <div ref="loadableCalendar"
    class="calendar-wrapper table-wrapper scrollable calendar-table"
    :class="name+'-table'"
    v-if="bots && (gridData.calendar || gridData.monthlyCalendar)"
  >

    <div class="select-week">
      <div class="previous" @click="changeWeek('previous', null, gridData.monthlyCalendar)">
        <i class="vs-icon notranslate icon-scale material-icons null">chevron_left</i>
      </div>
      <component-datepicker
        class="posts-datepicker"
        v-on:picked="picked"
        :date="new Date(currentDate)"
        :noLimit="true"
        :eventOpen="openDatePicker"
      ></component-datepicker>
      <span @click="openDatePicker = !openDatePicker" v-if="gridData.monthlyCalendar">{{ `${$t(`dash.planner.month`)} ${startDate.locale(this.$i18n.locale).format('MMMM')} ${startDate.locale(this.$i18n.locale).format('YYYY')} ` }}</span>
      <span @click="openDatePicker = !openDatePicker" v-else>{{ `${$t(`dash.planner.week`)} ${startDate.locale(this.$i18n.locale).format('LL')}` }}</span>
      <div class="next" @click="changeWeek('next',  null, gridData.monthlyCalendar)">
        <i class="vs-icon notranslate icon-scale material-icons null">chevron_right</i>
      </div>
    </div>
    <div class="scroll-hour" v-if="gridData.calendar">
      <label for="from-hour">{{ $t(`dash.planner.hours-period.from`) }}</label>
      <select id="from-hour" v-model="showStartHour" @change="checkValidPeriod('start')">
        <option v-for="(hour, index) in gridData.calendar.monday.slots"
          :key="index"
          :value="index"
        >{{ index }} h</option>
      </select>
      <label for="to-hour">{{ $t(`dash.planner.hours-period.to`) }}</label>
      <select id="to-hour" v-model="showEndHour" @change="checkValidPeriod('end')">
        <option v-for="(hour, index) in gridData.calendar.monday.slots"
          :key="index"
          :value="index"
        >{{ index }} h</option>
      </select>
    </div>

    <div class="show-empty-slots" @click="toggleShowEmptySlots()" v-if="pageWithAutoPost && gridData.calendar && !['Viewer'].includes(this.getUserRole)">
      {{ $t(`dash.planner.${showEmptySlots ? 'hide': 'show'}-empty-slot`) }} 
    </div>
    <div class="calendar-content" ref="loadableCalendarContent" v-if="gridData.calendar">
      <ul id="calendar-content-hours" class="calendar-body">
        <li class="column hours">
          <ul class="calendar-head" :class="{'fixed': fixedDays}">
            <li class="column hours-column"></li>
          </ul>
          <ul>
            <li class='row hour no-background' v-for="(hour, index) in gridData.calendar.monday.slots" :key="index" :class="`hour-${index} ${showStartHour > index || index > showEndHour ? 'hide' : ''}`" :style="`height: ${getHeightHour(index)}px; min-height: ${maxPostsHour(index)==0 ? 30 : 50}px`"> 
              <div>{{ index }}<span>h</span></div>
            </li>
          </ul>
        </li>
      </ul>
      <div class="scrollable-x">
        <ul id="calendar-content-days" class="calendar-body head-days">
          <li class="column day" v-for="(day, key) in gridData.calendar" :key="key" :class="`day-${key}`"> 
            <ul class="calendar-head" :class="{'fixed': fixedDays}">
              <li class="column day-column">
                <p :class="[{'past': checkPast(day.day, currentDate.hours()), 'current': checkCurrent(day.day)}]">
                  <span class="day">{{ $t(`dash.week.${formatDayEn(day.day, "dddd").toLowerCase()}`).substr(0, 3) }} {{ formatDate(day.day, "DD") }}</span>
                  <span class="posts">{{ nbPostsDay(key) }}</span>
                </p>
              </li>
            </ul>
          </li>
        </ul>
      <ul id="calendar-content" class="calendar-body scrollable" @scroll="handleScroll">
        <div class="drag-scroll-top" v-if="activeDropZone" @dragover="dragOver($event, 'top')"></div>
        <div class="drag-scroll-bottom" v-if="activeDropZone" @dragover="dragOver($event, 'bottom')"></div>
        <div class="cursor-current-hour" :style="`top: ${positionCursorHour}px`" v-if="showCursor && positionCursorHour>0 && (showStartHour > 0 || showEndHour < 23)"><span>{{ currentDate.format('HH:mm') }}</span></div>
        <li class="column day" v-for="(day, key) in gridData.calendar" :key="key" :class="`day-${key}`"> 
          <ul class="hours" :class="{'current': checkCurrent(day.day)}">
            <li class="row hour" v-for="(hour, index) in day.slots" :key="index" :class="[`hour-${index}`, showStartHour > index || index > showEndHour ? 'hide' : '', {'out' : checkPlanning(key, index), 'current' : isNow(day.day, index)}]" @click="addPost(day.day, index)" :style="`height: ${getHeightHour(index)}px; min-height: ${maxPostsHour(index)==0 ? 30 : 50}px`"> 
              <div class="hour">{{ $t(`dash.week.${formatDayEn(day.day, "dddd").toLowerCase()}`).substr(0, 3) }} {{ formatDate(day.day, "DD/MM") }} | {{ index }}h</div>
              <ul class="posts"> 
                <div v-for="(post, indexPost) in hour" :key="indexPost" class="post-cell" @dragend="dragEnd">
                  <!-- <li :data-qa="`planner-post-${post.status}`" v-if="showPost(post)" @click.stop.prevent="clickPost(gridData.pages, post)" class="post" :class="[post.status, {'tiktok': post.status === 'posted' && post.page[0].network === 'tiktok'}, {'reshare': post.page && post.page[0] && post.page[0].is_reshare}, {'retweet': post.page && post.page[0] && post.page[0].is_retweet}, {'story': post.page && post.page[0] && post.page[0].story}]" -->
                  <li :data-qa="`planner-post-${post.status}`" v-if="showPost(post)" @click.stop.prevent="clickPost(gridData.pages, post)" class="post" :class="[post.status, {'reshare': post.page && post.page[0] && post.page[0].is_reshare}, {'retweet': post.page && post.page[0] && post.page[0].is_retweet}, {'story': (post.page && post.page[0] && post.page[0].story) || (post.draft && post.draft.type === 'story')}]"
                        :draggable="!['Viewer'].includes(getUserRole) && ['scheduled', 'draft'].includes(post.status)" @dragstart='startDragPost($event, post, index)' @dragover.prevent> 
                    <div class="page-rs" v-if="post._bots && post._bots.length && post._bots[0].page && post._bots[0].page.name">
                      <Tooltip
                        :text="post._bots[0].page.name"
                        position="top"
                      >
                        <page-image-avatar :page="post._bots[0].page"/>
                        &nbsp;
                      </Tooltip>
                    </div>
                    <template  v-if="(post.status == 'preview' || post.status == 'slot' || post.status == 'failed' || post.status == 'inprogress' || (post.page && post.page[0] && post.page[0].story))">
                      <div class="content">
                        <Tooltip  :text="$t(getTooltip(post))" position="top">
                          <div v-if="((post.page && post.page[0] && post.page[0].story) || (post.draft && post.draft.type === 'story') || (post.page && post.page[0] && post.page[0].videoReel)) && ((post.page && post.page[0] && post.page[0].video) || ((post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.endsWith('.mp4'))) || (post.draft && post.draft.data.videos && getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)))" class="thumb-wrapper">
                            <video width="37" height="70" class="video-thumb" :src="post.page && post.page[0] && post.page[0].video ? post.page[0].video : (post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.endsWith('.mp4')) ? post.page[0].enclosure : getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)"></video>
                          </div>
                          <div v-else-if="post.status != 'slot' && ((post._bots[0] && post._bots[0].mode === 'story' && post._bots[0].page && post._bots[0].page.story_config && post._bots[0].page.story_config.created) || (post._bots && post._bots.mode === 'story' && post._bots.page && post._bots.page.story_config && post._bots.page.story_config.created) )" class="story-img-planner">
                            <img :src="post.enclosure" alt="" @error="replaceByDefault">
                            <p>{{getText(post, true)}}</p>
                          </div>
                          <div v-else-if="post.status != 'slot' && post.enclosure" class="thumb-wrapper">
                            <img class="thumb" :src="post.enclosure">
                          </div>
                          <div v-else-if="post.status != 'slot' && post.page && post.page[0] && post.page[0].enclosure" class="thumb-wrapper">
                            <img class="thumb" :src="post.page[0].enclosure" @error="replaceByDefault">
                          </div>
                          <div v-else-if="post.status != 'slot' && post.page && post.page[0] && post.page[0].carousel && post.page[0].carousel.length > 1 && post.page[0].carousel[0].url" class="thumb-wrapper">
                            <img class="thumb" :src="post.page[0].carousel[0].url">
                          </div>
                          <span class="title" v-if="post.status != 'slot'">{{ getText(post) }}</span>
                          <span class="title" v-else>{{ $t(`dash.post.slot.empty`) }}</span>                      
                        </Tooltip>
                      </div>
                      <div class="info">
                        <span class="date">{{ getDate(post) }}</span>
                        <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type" :class="getTypePost(post)">
                          <span>{{ getTypePost(post) }}</span>
                          &nbsp;
                        </Tooltip>
                        <!-- <span class="state">{{ $t(`dash.post.${post.status === 'posted' && post.page[0].network === 'tiktok' ? 'uploaded' : post.status}`) }}</span> -->
                        <span class="state">{{ $t(`dash.post.${post.status}`) }}</span>
                      </div>
                    </template>
                    <template v-else-if="post.page && post.page[0] && post.page[0].is_reshare">
                      <div class="content">
                        <div v-if="post.page && post.page[0] && post.page[0].enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.page[0].enclosure" @error="replaceByDefault">
                        </div>
                        <div v-else-if="post.enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.enclosure" @error="replaceByDefault">
                        </div>
                        <span class="title">{{ post.page[0].reshare_message }} - {{ getText(post) }}</span>
                      </div>
                      <div class="info">
                        <span class="date">{{ getDate(post) }}</span>
                        <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type" :class="getTypePost(post)">
                          <span>{{ getTypePost(post) }}</span>
                          &nbsp;
                        </Tooltip>
                        <span class="state">{{ $t(`dash.post.reshare`) }}</span>
                      </div>
                    </template>
                    <template v-else-if="post.page && post.page[0] && post.page[0].is_retweet">
                      <div class="content">
                        <div v-if="post.page && post.page[0] && post.page[0].enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.page[0].enclosure" @error="replaceByDefault">
                        </div>
                        <div v-else-if="post.enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.enclosure" @error="replaceByDefault">
                        </div>
                        <span class="title">{{ getText(post) }}</span>
                      </div>
                      <div class="info">
                        <span class="date">{{ getDate(post) }}</span>
                        <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type" :class="getTypePost(post)">
                          <span>{{ getTypePost(post) }}</span>
                          &nbsp;
                        </Tooltip>
                        <span class="state">{{ $t(`dash.posts.retweet`) }}</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="content">
                        <div v-if="((post.page && post.page[0] && post.page[0].story) || (post.draft && post.draft.type === 'story') || (post.page && post.page[0] && post.page[0].videoReel)) && (post.page && post.page[0] && post.page[0].video) || (post.draft && post.draft.data.videos && getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel))" class="thumb-wrapper">
                          <video width="37" height="70" class="video-thumb" :src="post.page && post.page[0] && post.page[0].video ? post.page[0].video : getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)"></video>
                        </div>
                        <div v-else-if="post.page && post.page[0] && post.page[0].enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.page[0].enclosure" @error="replaceByDefault">
                        </div>
                        <div v-else-if="post.page && post.page[0] && post.page[0].carousel && post.page[0].carousel.length > 1 && post.page[0].carousel[0].url" class="thumb-wrapper">
                          <img class="thumb" :src="post.page[0].carousel[0].url">
                        </div>
                        <div v-else-if="post.enclosure" class="thumb-wrapper">
                          <img v-if="post.draft && (post.draft.data.form.enclosure || post.draft.data.multipleImages.length)" class="thumb" :src="post.draft.data.multipleImages && post.draft.data.multipleImages.length ? post.draft.data.multipleImages[0].url : post.draft.data.form.enclosure" @error="replaceByDefault">
                          <img v-else-if="Array.isArray(post._bots)  && post._bots.length > 0 && post._bots[0].mode === 'story' && post.page && post.page[0] && post.page[0].story" class="story-screenshot-planner" :src="JSON.parse(post.page[0].story).screenshot" @error="replaceByDefault">
                          <img v-else-if="post._bots && post._bots.mode === 'story' && post.page && post.page[0] && post.page[0].story" class="story-screenshot-planner" :src="JSON.parse(post.page[0].story).screenshot" @error="replaceByDefault">
                          <img v-else class="thumb" :src="post.enclosure" @error="replaceByDefault">
                        </div>
                        <div v-else-if="(post.page && post.page[0] && post.page[0].video) || (post.draft && post.draft.data.videos && getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel))" class="thumb-wrapper">
                          <video width="75" class="video-thumb" :src="post.page && post.page[0] && post.page[0].video ? post.page[0].video : getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)"></video>
                        </div>
                        <span class="title">{{ getText(post) }}</span>
                      </div>
                      <div class="info">
                        <span class="date">{{ getDate(post) }}</span>
                        <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type" :class="getTypePost(post)">
                          <span>{{ getTypePost(post) }}</span>
                          &nbsp;
                        </Tooltip>
                        <!-- <span class="state">{{ $t(`dash.post.${post.status === 'posted' && post.page[0].network === 'tiktok' ? 'uploaded' : post.status}`) }}</span> -->
                        <span class="state">{{ $t(`dash.post.${post.status}`) }}</span>
                      </div>
                    </template>
                  </li>
                </div>
                <div class="post-cell drop-post" v-if="activeDropZone && !checkPast(day.day, index)" draggable @dragenter="dragEnterHour($event, index)">
                  <ul>
                    <li v-for="(minute, minuteKey) in [0,5,10,15,20,25,30,35,40,45,50,55]" :key="minuteKey" :date="`${index < 10 ? '0'+index : index}:${minute < 10 ? '0'+minute : minute}`" draggable @dragover.prevent @drop='onDropPost($event, day.day, index, minute)' @dragenter="dragEnter($event, index)" @dragleave="dragLeave($event, index)"></li>
                  </ul>
                </div>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      </div>
    </div>

    <div class="calendar-content monthly" ref="loadableCalendarContent" v-if="gridData.monthlyCalendar">
      <div class="scrollable-x">
        <ul id="calendar-content-days" class="calendar-body head-days">
          <li class="column day" v-for="(day, key) in daysWeek" :key="key" :class="`day-${key}`"> 
            <ul class="calendar-head" :class="{'fixed': fixedDays}">
              <li class="column day-column">
                <p>
                  <span class="day">{{ $t(`dash.week.${day}`).substr(0, 3) }}</span>
                </p>
              </li>
            </ul>
          </li>
        </ul>
        <div id="calendar-content-monthly">
          <div class="day" v-for="(day, indexDay) in gridData.monthlyCalendar" :key="indexDay" @click="addPost(day.dateText, null)" :class="{'current': checkCurrent(day.dateText, true), 'month': checkMonth(day.dateText)}">
            <div class="date">{{ day.date }}</div>
            <div class="count" v-if="nbPostsDayMonthly(day.posts)">{{ nbPostsDayMonthly(day.posts) }}</div>
            <ul class="posts"> 
              <div v-for="(post, indexPost) in day.posts" :key="indexPost" class="post-cell">
                <li :data-qa="`planner-post-${post.status}`" v-if="showPost(post)" @click.stop.prevent="clickPost(gridData.pages, post)" class="post" :class="[post.status, {'reshare': post.page && post.page[0] && post.page[0].is_reshare}, {'retweet': post.page && post.page[0] && post.page[0].is_retweet}, {'story': (post.page && post.page[0] && post.page[0].story) || (post.draft && post.draft.type === 'story')}]"> 
                  <div class="page-rs" v-if="post._bots && post._bots.length && post._bots[0].page && post._bots[0].page.name">
                    <Tooltip
                      :text="post._bots[0].page.name"
                      position="top"
                    >
                      <page-image-avatar :page="post._bots[0].page"/>
                      &nbsp;
                    </Tooltip>
                  </div>
                  <template v-if="(post.status == 'preview' || post.status == 'slot' || post.status == 'failed' || post.status == 'inprogress' || (post.page && post.page[0] && post.page[0].story))">
                    <div class="content">
                      <Tooltip :text="$t(getTooltip(post))" position="top">
                        <div v-if="((post.page && post.page[0] && post.page[0].story) || (post.draft && post.draft.type === 'story') || (post.page && post.page[0] && post.page[0].videoReel)) && ((post.page && post.page[0] && post.page[0].video) || ((post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.endsWith('.mp4'))) || (post.draft && post.draft.data.videos && getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)))" class="thumb-wrapper">
                            <video width="37" height="70" class="video-thumb" :src="post.page && post.page[0] && post.page[0].video ? post.page[0].video : (post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.endsWith('.mp4')) ? post.page[0].enclosure : getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)"></video>
                          </div>
                        <div v-else-if="post.status != 'slot' && ((post._bots[0] && post._bots[0].mode === 'story' && post._bots[0].page && post._bots[0].page.story_config && post._bots[0].page.story_config.created) || (post._bots && post._bots.mode === 'story' && post._bots.page && post._bots.page.story_config && post._bots.page.story_config.created) )" class="story-img-planner">
                          <img :src="post.enclosure" alt="" @error="replaceByDefault">
                          <p>{{getText(post, true)}}</p>
                        </div>
                        <div v-else-if="post.status != 'slot' && post.enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.enclosure">
                        </div>
                        <div v-else-if="post.status != 'slot' && post.page && post.page[0] && post.page[0].enclosure" class="thumb-wrapper">
                          <img class="thumb" :src="post.page[0].enclosure">
                        </div>
                        <div v-else-if="post.status != 'slot' && post.page && post.page[0] && post.page[0].carousel && post.page[0].carousel.length > 1 && post.page[0].carousel[0].url" class="thumb-wrapper">
                          <img class="thumb" :src="post.page[0].carousel[0].url">
                        </div>
                        <span class="title" v-if="post.status != 'slot'">{{ getText(post) }}</span>
                        <span class="title" v-else>{{ $t(`dash.post.slot.empty`) }}</span>
                      </Tooltip>
                    </div>
                    <div class="info">
                      <span class="date">{{ getDate(post) }}</span>
                      <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type" :class="getTypePost(post)">
                        <span>{{ getTypePost(post) }}</span>
                        &nbsp;
                      </Tooltip>
                      <span class="state">{{ $t(`dash.post.${post.status}`) }}</span>
                    </div>
                  </template>
                  <template v-else-if="post.page && post.page[0] && post.page[0].is_reshare">
                    <div class="content">
                      <div v-if="post.page && post.page[0] && post.page[0].enclosure" class="thumb-wrapper">
                        <img class="thumb" :src="post.page[0].enclosure" @error="replaceByDefault">
                      </div>
                      <div v-else-if="post.enclosure" class="thumb-wrapper">
                        <img class="thumb" :src="post.enclosure" @error="replaceByDefault">
                      </div>
                      <span class="title">{{ post.page[0].reshare_message }} - {{ getText(post) }}</span>
                    </div>
                    <div class="info">
                      <span class="date">{{ getDate(post) }}</span>
                      <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type" :class="getTypePost(post)">
                        <span>{{ getTypePost(post) }}</span>
                        &nbsp;
                      </Tooltip>
                      <span class="state">{{ $t(`dash.post.reshare`) }}</span>
                    </div>
                  </template>
                  <template v-else-if="post.page && post.page[0] && post.page[0].is_retweet">
                    <div class="content">
                      <div v-if="post.page && post.page[0] && post.page[0].enclosure" class="thumb-wrapper">
                        <img class="thumb" :src="post.page[0].enclosure" @error="replaceByDefault">
                      </div>
                      <div v-else-if="post.enclosure" class="thumb-wrapper">
                        <img class="thumb" :src="post.enclosure" @error="replaceByDefault">
                      </div>
                      <span class="title">{{ getText(post) }}</span>
                    </div>
                    <div class="info">
                      <span class="date">{{ getDate(post) }}</span>
                      <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type" :class="getTypePost(post)">
                        <span>{{ getTypePost(post) }}</span>
                        &nbsp;
                      </Tooltip>
                      <span class="state">{{ $t(`dash.posts.retweet`) }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="content">
                      <div v-if="((post.page && post.page[0] && post.page[0].story) || (post.draft && post.draft.type === 'story') || (post.page && post.page[0] && post.page[0].videoReel)) && ((post.page && post.page[0] && post.page[0].video) || ((post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.endsWith('.mp4'))) || (post.draft && post.draft.data.videos && getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)))" class="thumb-wrapper">
                            <video width="37" height="70" class="video-thumb" :src="post.page && post.page[0] && post.page[0].video ? post.page[0].video : (post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.endsWith('.mp4')) ? post.page[0].enclosure : getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)"></video>
                      </div>
                      <div v-else-if="post.page && post.page[0] && post.page[0].enclosure" class="thumb-wrapper">
                        <img class="thumb" :src="post.page[0].enclosure" @error="replaceByDefault">
                      </div>
                      <div v-else-if="post.page && post.page[0] && post.page[0].carousel && post.page[0].carousel.length > 1 && post.page[0].carousel[0].url" class="thumb-wrapper">
                          <img class="thumb" :src="post.page[0].carousel[0].url">
                      </div>
                      <div v-else-if="post.enclosure" class="thumb-wrapper">
                        <img v-if="post.draft && (post.draft.data.form.enclosure || post.draft.data.multipleImages.length)" class="thumb" :src="post.draft.data.multipleImages && post.draft.data.multipleImages.length ? post.draft.data.multipleImages[0].url : post.draft.data.form.enclosure" @error="replaceByDefault">
                        <img v-else-if="Array.isArray(post._bots)  && post._bots.length > 0 && post._bots[0].mode === 'story' && post.page && post.page[0] && post.page[0].story" class="story-screenshot-planner" :src="JSON.parse(post.page[0].story).screenshot" @error="replaceByDefault">
                        <img v-else-if="post._bots && post._bots.mode === 'story' && post.page && post.page[0] && post.page[0].story" class="story-screenshot-planner" :src="JSON.parse(post.page[0].story).screenshot" @error="replaceByDefault">
                        <img v-else class="thumb" :src="post.enclosure" @error="replaceByDefault">
                      </div>
                      <div v-else-if="(post.page && post.page[0] && post.page[0].video) || (post.draft && post.draft.data.videos && getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel))" class="thumb-wrapper">
                        <video width="75" class="video-thumb" :src="post.page && post.page[0] && post.page[0].video ? post.page[0].video : getUrlVideoDraft(post.draft.data.videos, post.page[0].network, post.draft.type, post.draft.data.videoReel)"></video>
                      </div>
                      <span class="title">{{ getText(post) }}</span>
                    </div>
                    <div class="info">
                      <span class="date">{{ getDate(post) }}</span>
                      <Tooltip :text="$t(getTypeTooltip(post))" position="top" v-if="post.status != 'slot'" class="type" :class="getTypePost(post)">
                        <span>{{ getTypePost(post) }}</span>
                        &nbsp;
                      </Tooltip>
                      <span class="state">{{ $t(`dash.post.${post.status}`) }}</span>
                    </div>
                  </template>
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>

   

    <vs-popup class="sidebar-action" :title="``" :active.sync="showSidebar">
      <component-post-sidebar 
        v-if="gridData.pages && post && post._bots"
        :gridData="gridData" 
        :postOriginal="post"
        :sectionPlanner="true"
        v-on:edit="editPost"
        v-on:validate="validatePostEvent"
        v-on:deleteScheduled="deleteScheduledEvent"
        v-on:add="addPostEvent"
        v-on:excludeNews="excludeNewsEvent"
        v-on:deleteSlot="deleteSlotEvent"
        v-on:resharePost="resharePost"
        v-on:retweetPost="retweetPost"
        v-on:openLoader="openLoader"
        v-on:validateScheduledPost="validateScheduledPostEvent"
        v-on:addComment="addComment"
        v-on:shareStory="shareToStory"
        v-on:editDraft="editDraft"
        v-on:removeDrafts="removeDrafts"
        v-on:duplicatePost="duplicatePost"
      ></component-post-sidebar>
    </vs-popup>
  </div>
</template>

<script>
import moment from 'moment'
import PreviewPost from './PreviewPost.vue'
import componentDatepicker from './Datepicker.vue'
import componentPostSidebar from './PostSidebar.vue'
import PageImageAvatar from './PageImageAvatar.vue'
import ClickOutside from 'vue-click-outside'
import Bots from './../mixins/Bots'
import Posts from './../mixins/Posts'
import Insights from './../mixins/Insights'
import Common from './../mixins/Common'
import Notif from './../mixins/Notif'
import Popup from '../../utils/Popup'
import imgDefault from '../../assets/img/no-picture.png'
import Tooltip from './tooltip/tooltipInit.vue'

export default {
  name: 'component-posts-calendar',

  mixins: [Common, Insights, Bots, Posts, Notif],

  components: {
    PreviewPost,
    componentDatepicker,
    componentPostSidebar,
    PageImageAvatar,
    Tooltip
  },

  directives: {
    ClickOutside,
  },

  props: {
    gridData: Object,
    columns: Array,
    canUseCustomSources: Boolean,
    page: {
      type: Number,
      required: true
    },
    pages: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    filter: {
      type: Array,
      required: true
    },
    isDeleteSlot: Boolean,
    slotDate: String,
    slotBot: Object,
    startDate: Object
  },

  data() {
    return {
      sources: null,
      bots: null,
     // startDate: moment().hour(0).minute(0).second(0),
      endDate: moment().add(6, 'days').hour(23).minute(59).second(59),
      currentDate: moment(),
      openDatePicker: false,
      positionCursorHour: 0,
      daysWeek: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      calendar: {
        monday: {
          day: null,
          slots: null
        },
        tuesday:  {
          day: null,
          slots: null
        },
        wednesday:  {
          day: null,
          slots: null
        },
        thursday:  {
          day: null,
          slots: null
        },
        friday:  {
          day: null,
          slots: null
        },
        saturday:  {
          day: null,
          slots: null
        },
        sunday:  {
          day: null,
          slots: null
        }
      },
      posts: [],
      showSidebar: false,
      post: {
        id: null,
        title: null,
        description: null,
        url: null,
        posted_date: null,
        scheduled_date: null,
        preview_date: null,
        date: null,
        status: null, // 0 preview - 1 scheduled - 2 posted - 3 inprogress
        page: null,
        enclosure: null,
        stats: null,
        _bots: null
      },
      excludedSlots: [],
      load: false,
      changeNews: null,
      
      fixedDays: false,

      showEmptySlots: false,
      activeAutoScroll: false,

      autoscrollHour: -1,
      showStartHour: 0,
      showEndHour: 23,
      
      activeDropZone: false,
      hourActiveDropZone: null,
      scrollSpeed: 1,
      lastScroll: Date.now()
    }
  },

  async mounted() {
    if(localStorage.showEmptySlots)
      this.showEmptySlots = JSON.parse(localStorage.getItem('showEmptySlots'))
     
    // this.bots = localStorage.bots && localStorage.bots != "undefined" ? JSON.parse(localStorage.bots).filter(b => b.page.id == this.gridData.pages.id) : []
    this.bots = localStorage.bots && localStorage.bots != "undefined" ? JSON.parse(localStorage.bots).filter(b => this.pages.map(p => p.id).includes(b.page.id)) : []
    this.initDaysWeekTab(this.startDate)
  },

  beforeMount() {
    window.addEventListener('scroll', this.scroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll)
  },

  methods: {

    getUrlVideoDraft(videos, network, type, reel){
      if(videos && JSON.parse(videos)){
        videos = JSON.parse(videos)
        return network == 'instagram' && type == 'story' ?  videos['story'] : (network == 'instagram' && reel ? videos['instagram_reel'] : videos[network])
      }
      return false
    },

    handleScroll() {
       const container = this.$el.querySelector("#calendar-content");
      const containerDays = this.$el.querySelector("#calendar-content-days");
      const containerHours = this.$el.querySelector("#calendar-content-hours");
      containerDays.scrollLeft = container.scrollLeft;
      containerHours.scrollTop = container.scrollTop;
    },

    getText(entry, title=false){

    let text = entry._bots && entry._bots.post_text_layout == 'description' ? entry.description : entry.title

    if(title) text = entry.title

    if(!text) text = ""

    let maxWhile = 100
    let countWhile = 0
    if(entry.draft){
      //replace multi-mention
      while(text.includes('@[MENTIONS-') && countWhile<maxWhile){
        countWhile++
        let start = text.indexOf('@[MENTIONS-')
        let end = text.indexOf(']', start)
        let index = parseInt(text.substr(start, end+1).replace('@[MENTIONS-', '').replace(']', ''))
        if(entry.draft.data.validMentions[index-1]) {
          let mention = entry.draft.data.validMentions[index-1].find(m => m.network == this.gridData.pages.network)
          if(mention && mention.value) 
            switch(mention.network){
              case 'twitter':
              case 'instagram':
                mention = mention.value.includes('@[') ? `@${mention.value.substring(2, mention.value.indexOf('('))}` : mention.value
                break
              case 'facebook':
              case 'linkedin':
                mention = mention.value.substring(2, mention.value.indexOf('('))
                break
              default:
          }
          else if(mention && mention.word){
            mention = mention.word
          }
          text = text.substr(0, start) + (mention ? mention : entry.draft.data.validMentions[index-1][0].word) + text.substr(end+1)
        }
        else text = text.substr(0, start) + text.substr(end+1)
      }
    }

    countWhile = 0
    //replace mention affected
    while(text.includes('@[') && countWhile<maxWhile){
      countWhile++
      let start = text.indexOf('@[')
      let end = text.indexOf(']', start)
      let mention = {
        network: this.gridData.pages.network,
        value: text.substr(start, end-start+1)
      }
      if(mention) 
        switch(mention.network){
          case 'twitter':
          case 'instagram':
            mention = mention.value
            break
          case 'facebook':
          case 'linkedin':
            mention = `@${mention.value.substring(2, mention.value.indexOf('('))}`
            break
          default:
        }
      text = text.substr(0, start) + (mention ? mention : '') + text.substr(end+1)

      if(text && text.length > 280)
        text = text.substr(0, text.substr(0, 280 - 4).lastIndexOf(" ")) + " ..."
    }
    
    return text
  },

  postInSelectedPages(post) {
    if(post && post._bots && post._bots[0] && post._bots[0].page)
      return this.pages.map(page => page.id).includes(post._bots[0].page.id || post._bots[0].page)
    else if(post && post._bots && post._bots && post._bots.page)
      return this.pages.map(page => page.id).includes(post._bots.page.id || post._bots.page)
    return false
  },

    showPost(post){
      if((!this.showEmptySlots || ['Viewer'].includes(this.getUserRole)) && post.status == 'slot')
        return false
      if(this.filter.includes('all'))
        return true && this.postInSelectedPages(post)
      let status = 'queue'
      if(['scheduled', 'inprogress'].includes(post.status))
        status = 'scheduled'
      else if(['posted'].includes(post.status))
        status = 'posted'
      else if(['failed'].includes(post.status))
        status = 'failed'
      else if(['draft'].includes(post.status))
        status = 'draft'

      return this.filter.includes(status) && this.postInSelectedPages(post)
    },

    scroll() {
      this.fixedDays = window.scrollY >= 450
    },

    replaceByDefault(e) {
      e.target.src = imgDefault
    },

    /**
     * Date picked
     */
    picked(date) {
      this.openDatePicker = false
      this.initDaysWeekTab(date)
    },

    toggleSidebar(){
      this.showSidebar = !this.showSidebar
    },
    closeSidebar() {
      this.showSidebar = false
    },

    startOfWeek(date){
      let diff = moment(date).date() - moment(date).day() + (moment(date).day() === 0 ? -6 : 1)
      return moment(date).date(diff).hour(0).minute(0).second(0)
    },

    initDaysWeekTab(dateDebut, monthly=false) {
      new Promise((resolve, reject) => {

        let date = this.startOfWeek(dateDebut)
        if(monthly)
          date = moment(dateDebut).startOf('month')

        this.$emit('changeStartDate', date)
        this.endDate= moment(date).add(6, 'days').hour(23).minute(59).second(59)
        if(monthly)
          this.endDate = moment(date).endOf('month')

        this.$emit('reload', date, this.endDate)

        resolve()
      })
    },

    changeWeek(direction, inputDate=null, monthly=false) {
      let date
      if(direction == "previous"){
        date = monthly ? moment(this.startDate).subtract(1, 'months')
                       : moment(this.startDate).subtract(7, 'days')
      }
      else if(direction == "next") {
        date = monthly ? moment(this.startDate).add(1, 'months')
                       : moment(this.startDate).add(7, 'days')
      }
      else {
        date = inputDate
      }
      this.activeAutoScroll = false
      this.initDaysWeekTab(date, monthly)
    },

    formatDate(dateToFormat, format) {
      return moment(dateToFormat)
        .local()
        .format(format)
    },

    formatDayEn(dateToFormat, format) {
      return moment(dateToFormat)
        .locale('en')
        .format(format)
    },

    formatDateToUTC(date){
      let year = new Date(date).getUTCFullYear()

      let month = new Date(date).getUTCMonth() + 1
      month = month < 10 ? `0${month}` : month
      
      let day = new Date(date).getUTCDate()
      day = day < 10 ? `0${day}` : day

      let hour = new Date(date).getUTCHours()
      hour = hour < 10 ? `0${hour}` : hour
      
      let minute = new Date(date).getUTCMinutes()
      minute = minute < 10 ? `0${minute}` : minute

      let seconde = new Date(date).getUTCSeconds()
      seconde = seconde < 10 ? `0${seconde}` : seconde

      return `${year}-${month}-${day}T${hour}:${minute}:${seconde}`
    },

    getDate(post){      
      let key = post.page ? Object.keys(post.page)[0] : null

      
      if(post.page && post.page[key] && post.page[key].posted_date) return this.formatDate(post.page[key].posted_date, 'HH:mm')     
      else if(post.page && post.page[key] && post.page[key].scheduled_date) return this.formatDate(post.page[key].scheduled_date, 'HH:mm')
      else if(post.preview_date) return this.formatDate(post.preview_date, 'HH:mm')
      else if(post.status == "slot") return this.formatDate(post.date, 'HH:mm')
      else if(post.status == "draft") return this.formatDate(post.scheduled_date, 'HH:mm')
    },

    getTypePost(post){
      if(post.page && post.page[0] && post.page[0].isScheduledPost)
        return 'P' //'A'
      if(post.page && post.page[0] && (post.page[0].is_manual_post || post.page[0].isManualPost))
        return 'M'
      if(post.draft)
        return 'P'
      return 'A'
    },

    getTypeTooltip(post){
      if(post.page && post.page[0] && post.page[0].isScheduledPost)
        return 'dash.post.type.scheduled'
      if(post.page && post.page[0] && (post.page[0].is_manual_post || post.page[0].isManualPost))
        return 'dash.post.type.manual'
      return 'dash.post.type.auto'
    },

    toggleShowEmptySlots(){
      this.showEmptySlots = !this.showEmptySlots
      localStorage.setItem('showEmptySlots', this.showEmptySlots)
    },

    convertPlanningToLocale(planningUTC){
      let days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      //convert planning to locale
      let planning = {}
      for (let day in planningUTC) planning[day] = {}
      for (let day in planningUTC) {
        for (let hour in planningUTC[day]) {
          let hourLocale = new Date(new Date().setUTCHours(hour)).getHours()
          let dayLocale = day
          if(parseInt(hourLocale) < parseInt(hour)){
            //tomorrow
            dayLocale = days[days.indexOf(day)+1]
            if(!dayLocale) dayLocale = days[0]
          }
          planning[dayLocale][hourLocale] = planningUTC[day][hour] ? true : false
        }
      }
      return planning
    },

    checkPlanning(day, hour) {
      let tabCheck = []
      this.bots.forEach(bot => {
        let planning = bot && bot.planning ? this.convertPlanningToLocale(bot.planning) : null
        tabCheck.push(planning ? planning[day][hour] : true)
      })      
      return !tabCheck.includes(true)
    },

    checkPast(day, hour) {
      let hourToCheck = moment(day).hour(hour)
      let currentHour = moment(this.currentDate).minute(0).second(0)
      return hourToCheck.isBefore(currentHour)
    },

    checkCurrent(day, local=false) {
      let currentDay = moment().utc().hour(0).minute(0).second(0)
      let isSameDay = moment(day).utc().format() == currentDay.format()
      if(local)
        isSameDay = moment(day).format('YYYY-MM-DD') == currentDay.format('YYYY-MM-DD')
      return isSameDay
    },

    checkMonth(day) {
      return this.startDate.isSame(moment(day), 'month')
    },

    isNow(day, hour){
      return this.currentDate.hours() == hour && moment(day).isSame(this.currentDate, 'day')
    },

    getTooltip(post) {

      if(post.page && post.page[0] && post.page[0].story)
        return 'Story'

      switch(post.status) {
        case 'posted': return ''
        case 'scheduled': return ''
        case 'failed': return post.page && post.page[0] && post.page[0].post_number ? post.page[0].post_number : 'dash.post.failed.tooltip'
        case 'preview': return 'dash.scheduler.tooltip.preview'
        case 'slot': return 'dash.scheduler.tooltip.slot'
      }
    },

    editPost(page, id, status, deleteSlot=false, slotDate=null, bot=null){
      this.showSidebar = false
      if(status == "preview") this.$emit('edit', page, id, "inqueue", deleteSlot, slotDate, bot)
      else if(status == "scheduled") this.$emit('edit', page, id, "scheduled")
      else if(status == "failed") this.$emit('edit', page, id, "inqueue")
    },

    duplicatePost(page, post, unique=false){
      this.showSidebar = false
      this.$emit('duplicatePost', page, post, unique)
    },
    
    shareToStory(page, id, media) {
      this.closeSidebar();
      this.$emit('shareStory', page, id, media)
    },

    resharePost(pageId, newsId, pageEmbed){
      this.closeSidebar()
      console.log('resharePost', pageId, newsId, pageEmbed)
      this.$emit('resharePost', pageId, newsId, pageEmbed)
    },

    retweetPost(pageId, newsId, pageEmbed){
      this.closeSidebar()
      console.log('retweetPost', pageId, newsId, pageEmbed)
      this.$emit('retweetPost', pageId, newsId, pageEmbed)
    },

    deleteSlot(date, bot){
      if(Array.isArray(bot))
        bot = bot[0]
      date = this.formatDate(date, 'YYYY-MM-DDTHH:mm:ss')
      date = this.formatDateToUTC(date)
      this.deleteSlotByBot(bot.id, date).then(async res => {

        const { success } = res.body

        if(this.activeLog){
          let messageLog = `${res.url} --- ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'delete-slot', messageLog)
        }

        if (!success) {
          const notif = {
            color:'primary',
            title: this.$t('dash.posts.error.title'),
            text: this.$t('dash.scheduler.error.delete_slot'),
            id: bot.id
          }
          this.notify(notif, {
            component: "PostCalendar",
            action: "deleteSlot",
            params: {
              botId: bot.id, 
              date: date
            }
          })
          return
        }

        this.showSidebar = false
      })
    },

    editDraft(post) {
      console.log('editDraft', post)
      this.$emit('editDraft', post.draft)
      this.showSidebar = false
    },

    /**
     * actions on click post
     * @param {Number} id - posts id to update
     */
    clickPost(page, post) {
      
      this.showSidebar = true

      if(post.status === 'draft') {
        this.post.id = post.id || null
        this.post._id = post.id || null
        this.post.title = this.getText(post) || null
        this.post.description = post.description || null
        this.post.url = post.url || null
        this.post.posted_date = post.status == 'posted' ? post.page[0].posted_date : null
        this.post.scheduled_date = post.status == 'scheduled' || post.status == 'failed' ? post.page[0].scheduled_date : null
        this.post.preview_date = post.status == 'preview' ? post.preview_date : null
        this.post.date = post.status == 'slot' ? post.date : null
        this.post.status = post.status
        this.post.page = post.page || null   
        this.post._bots = post._bots || null
        this.post.flux = post.flux || null

        this.post.typePost = post.draft.data.typePost
        this.post.screenshot = post.draft.data.screenshot
        this.post.videoReel = post.draft.data.videoReel
        this.post.videos = post.draft.data.videos ? JSON.parse(post.draft.data.videos) : []
        this.post.location = post.draft.data.location ? JSON.parse(post.draft.data.location) : null
        this.post.data = post.draft.data
      }
      else {
        this.post.id = post.id || null
        this.post._id = post.id || null
        this.post.title = post.title || null
        this.post.description = post.description || null
        this.post.url = post.url || null
        this.post.posted_date = post.status == 'posted' ? post.page[0].posted_date : null
        this.post.scheduled_date = post.status == 'scheduled' || post.status == 'failed' ? post.page[0].scheduled_date : null
        this.post.preview_date = post.status == 'preview' ? post.preview_date : null
        this.post.date = post.status == 'slot' ? post.date : null
        this.post.status = post.status
        this.post.page = post.page || null   
  
        this.post._bots = post._bots || null
        this.post.flux = post.flux || null
  
        this.processInsights(post, this.page)
      }
    },

    startDragPost(evt, post, hour){
      console.log('startDragPost', evt, post)
      if(['scheduled', 'draft'].includes(post.status)) {
        evt.dataTransfer.dropEffect = 'move'
        evt.dataTransfer.effectAllowed = 'move'
        evt.dataTransfer.setData('postDragged', JSON.stringify(post))
        setTimeout(() => this.activeDropZone = true, 50)
        // this.activeDropZone = true
        this.hourActiveDropZone = hour
      }
    },

    async onDropPost(evt, date, hour=null, minute=0){
      let postDragged  = evt.dataTransfer.getData('postDragged')
      
      if(postDragged) {
        postDragged = JSON.parse(postDragged)
        let allStorification = false; 
        let allMultipage = false;
        let linkedStoificationPosts = this.gridData.posts.filter(e => e.id === postDragged.id);
        console.log('onDropPost', evt, date, hour, postDragged)
        // this.$emit('edit', postDragged._bots[0].page.id, postDragged.id, "scheduled", false, null, null, date, hour)
        // this.openLoader(true)
        let scheduledDate = moment(date).set('hour', hour)
        scheduledDate = scheduledDate.set('minute', minute)
        scheduledDate = scheduledDate.utc().format()
        const isMultipages = (postDragged.page[0].posts_multipages && postDragged.page[0].posts_multipages.length && postDragged.page[0].posts_multipages.reduce((acc, val) => {if (!acc.map(e => e.bot).includes(val.bot)) {acc.push(val);}return acc;}, []).length > 1
                                  && JSON.parse(localStorage.pages).filter(p => postDragged.page[0].posts_multipages.find(m => m.page == p.id)).length == postDragged.page[0].posts_multipages.length) 
         || (postDragged.status == 'draft' && postDragged.draft.data.bot.length > 1)
         || (linkedStoificationPosts && linkedStoificationPosts.length > 0 && linkedStoificationPosts.some(e => e.page && e.page[0].posts_multipages && e.page[0].posts_multipages.length && e.page[0].posts_multipages.reduce((acc, val) => {if (!acc.map(e => e.bot).includes(val.bot)) {acc.push(val);}return acc;}, []).length > 1 && JSON.parse(localStorage.pages).filter(p => e.page[0].posts_multipages.find(m => m.page == p.id)).length == e.page[0].posts_multipages.length))

        if(isMultipages){
          allMultipage = await new Promise((resolve, reject) => {
            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.posts.multi-pages.change_scheduled_date.title'),
              text: this.$t('dash.posts.change_scheduled_date.body'),
              cancelText: this.$t('dash.posts.multi-pages.remove.prompt.btn-only-one'),
              cancel: async () => {        
                resolve(false);
              },
              acceptText: this.$t('dash.posts.multi-pages.remove.prompt.btn-all'),
              accept: async () => {        
                resolve(true);
              }
            })
          }) 
          
        }

        if (linkedStoificationPosts.length > 1 && linkedStoificationPosts.some(e => e.page[0].storification) && linkedStoificationPosts.some(e => !e.page[0].storification)) {
          const postDraggedIsStorification = postDragged.page[0].storification
          let dateToTest = postDraggedIsStorification ? linkedStoificationPosts.find(e => !e.page[0].storification).page[0].scheduled_date : linkedStoificationPosts.find(e => e.page[0].storification).page[0].scheduled_date
          console.log(postDragged.page[0].storification , moment(scheduledDate).unix(), moment(dateToTest).unix());
          if (((postDragged.page[0].storification && moment(scheduledDate).unix() < moment(dateToTest).unix()) || (!postDragged.page[0].storification && moment(scheduledDate).unix() > moment(dateToTest).unix()))) {
            allStorification = true;
            // allStorification = await new Promise((resolve, reject) => {
            //   this.$vs.dialog({
            //     type:'confirm',
            //     color: 'primary',
            //     title: this.$t('dash.posts.multi-pages.change_scheduled_date.storification.limit'),
            //     text: this.$t('dash.posts.change_scheduled_date.body.storification.limit'),
            //     cancelText: this.$t('dash.posts.disclaimer-post.change-tab.prompt.btn-cancel'),
            //     cancel: async () => {        
            //       resolve("cancel");
            //     },
            //     acceptText: this.$t('dash.posts.multi-pages.remove.prompt.btn-all'),
            //     accept: async () => {        
            //       resolve(true)
            //     }
            //   })
            // })
          } else if (!isMultipages) {
          // if (allStorification === 'cancel') return;
            allStorification = await new Promise((resolve, reject) => {
              this.$vs.dialog({
                type:'confirm',
                color: 'primary',
                title: postDraggedIsStorification ? this.$t('dash.posts.multi-pages.change_scheduled_date.storification') : this.$t('dash.posts.multi-pages.change_scheduled_date.storification.linked'),
                text: postDraggedIsStorification ? this.$t('dash.posts.change_scheduled_date.body.storification') : this.$t('dash.posts.change_scheduled_date.body.storification.linked'),
                cancelText: postDraggedIsStorification ? this.$t('dash.posts.multi-pages.remove.prompt.btn-only-one.storification') : this.$t('dash.posts.multi-pages.remove.prompt.btn-only-one'),
                cancel: async () => {        
                  resolve(false);
                },
                acceptText: this.$t('dash.posts.multi-pages.remove.prompt.btn-all'),
                accept: async () => {        
                  resolve(true)
                }
              })
            })
          }
        }

        if (allMultipage) {
          allStorification = true;
        }

        this.$emit('openLoader', true)
        await this.updatePostScheduledDate(postDragged, {date, hour, minute, scheduledDate}, allMultipage, allStorification)
        .then(() => setTimeout(() => this.$emit('reload', date, this.endDate), 1000))

        // if((postDragged.page[0].posts_multipages && postDragged.page[0].posts_multipages.length) || (postDragged.status == 'draft' && postDragged.draft.data.bot.length > 1)
        //  || (allStorification && linkedStoificationPosts.some(e => e.page && e.page[0].posts_multipages && e.page[0].posts_multipages.length))){
        //   this.$vs.dialog({
        //     type:'confirm',
        //     color: 'primary',
        //     title: this.$t('dash.posts.multi-pages.change_scheduled_date.title'),
        //     text: this.$t('dash.posts.change_scheduled_date.body'),
        //     cancelText: this.$t('dash.posts.multi-pages.remove.prompt.btn-only-one'),
        //     cancel: async () => {        
        //       this.$emit('openLoader', true)
        //       await this.updatePostScheduledDate(postDragged, {date, hour, minute, scheduledDate}, false, allStorification)
        //       .then(() => setTimeout(() => this.$emit('reload', date, this.endDate), 1000))
        //     },
        //     acceptText: this.$t('dash.posts.multi-pages.remove.prompt.btn-all'),
        //     accept: async () => {        
        //       this.$emit('openLoader', true)
        //       await this.updatePostScheduledDate(postDragged, {date, hour, minute, scheduledDate}, true, allStorification)
        //       .then(() => setTimeout(() => this.$emit('reload', date, this.endDate), 1000))
        //     }
        //   })
        // }
        // else {        
        //   this.$emit('openLoader', true)
        //   await this.updatePostScheduledDate(postDragged, {date, hour, minute, scheduledDate}, false, allStorification)
        //   .then(() => setTimeout(() => this.$emit('reload', date, this.endDate), 1000))
        //   // .then(() => this.$emit('reload', date, this.endDate))
        // }
      }
    },

    dragEnterHour(ev, hour){
      // console.log('dragEnterHour',ev, hour)
      this.hourActiveDropZone = hour
    },
    dragEnter(ev, hour) {
      const allElements = document.querySelectorAll('.show-date');
      allElements.forEach((element) => {
        element.classList.remove('show-date');
      });
      // console.log('dragEnter',ev, hour)
      // ev.target.style.border = '2px solid #b20564'
      ev.target.classList="show-date"
      this.hourActiveDropZone = hour
    },
    dragLeave(ev, hour) {
      // console.log('dragLeave',ev, hour)
      // ev.target.style.border = 'none'
      ev.target.classList=""
    },
    dragEnd() {
      setTimeout(() => this.activeDropZone = false, 50)
      this.hourActiveDropZone = null
    },

    dragOver(ev, direction) {

      if(Date.now() - this.lastScroll > 200){
        this.lastScroll = Date.now()

        let body = document.body,
            html = document.documentElement;

        let heightDocument = Math.max( body.scrollHeight, body.offsetHeight, 
                                          html.clientHeight, html.scrollHeight, html.offsetHeight );
        
        let scroll = document.documentElement.scrollTop

        if(direction == 'top' && scroll > 0){
          this.showStartHour = 0
          this.scrollSpeed = Math.min(this.scrollSpeed > 0 ? -1 : this.scrollSpeed - 1, -50)
          scroll = scroll + this.scrollSpeed >= 0 ? scroll + this.scrollSpeed : 0 
        }
        else if(direction == 'bottom' && scroll < heightDocument) {
          this.showEndHour = 23
          this.scrollSpeed = Math.max(this.scrollSpeed < 0 ? 1 : this.scrollSpeed + 1, 50)
          scroll = scroll + this.scrollSpeed <= heightDocument ? scroll + this.scrollSpeed : heightDocument
        }

        document.documentElement.scrollTop = scroll
        // scrollTo({ top: scroll, left: 0, behavior: 'smooth' })
      }
    },

    addPost(day, hour, date=null, bot=null){
      if(!hour)
        hour = moment().local().hour()
      if(this.bots.length > 0){
        if(date){
          day = moment(date).local().hours(0).minutes(0).seconds(0)
          hour = moment(date).local().hours()
          let minute = moment(date).local().minutes()
          this.$emit('add', true, day, hour, minute, true, date, bot)
        } 
        else if(moment(day).hours(hour).unix() > moment().minutes(0).seconds(0).unix() && this.bots[0].status == 1)
          this.$emit('add', true, day, hour)
      }
    },

    maxPostsHour(hour){
      // return 1
      let max = 0
      for(const cal in this.gridData.calendar)
        if(this.gridData.calendar[cal].slots[hour].length > max) max = this.gridData.calendar[cal].slots[hour].length
      return max
    },

    getHeightHour(hour){
      // return 135
      let max = 0
      let slots
      for(const cal in this.gridData.calendar){
        let datas = this.showEmptySlots 
                        ? this.gridData.calendar[cal].slots[hour]
                        : this.gridData.calendar[cal].slots[hour].filter(slot => slot.status != 'slot')
        if(datas.length > max) {
          max = datas.length
          slots = datas
        }
      }

      let height = 0
      if(slots){
        slots.forEach(s => {
          if(s.page && s.page[0] && s.page[0].story){
            height += 80 + 5
          }
          else {
            height += 60 + 5
          }
        })
        height += 60 + 10
      }

      if(this.activeDropZone && this.hourActiveDropZone == hour)
        height += 12 * 20 - 30

      return height
    },

    nbPostsDay(day){
      let count = 0
      for(const hour in this.gridData.calendar[day].slots)
        count += this.gridData.calendar[day].slots[hour].filter(post => post.status != 'slot' && this.showPost(post) && this.pages.find(page => Array.isArray(post._bots) ? page.id == post._bots[0].page.id : page.id == post._bots.page.id)).length
      return count
    },

    nbPostsDayMonthly(dayPosts){
      return dayPosts.filter(post => post.status != 'slot' && this.showPost(post) && this.pages.find(page => page.id == post._bots[0].page.id)).length
    },

    processInsights(post, index) {
      if(post.page && post.page.length > 0 &&
        (
          post.page[0].status == 2 ||
          (post.page[0].status == 1 && new Date(post.page[0].scheduled_date).getTime() <= new Date().getTime())
        )
      ){
        this.getInsights([post]).then(res => {          
          this.post.stats = res.body.posts[0].page[0].insights || null  
        })
      }
    },

    checkValidPeriod(select){
      if(select == 'start') {
        if(this.showStartHour >= this.showEndHour)
          this.showEndHour = this.showStartHour
      }
      else if(select == 'end') {
        if(this.showStartHour >= this.showEndHour)
          this.showStartHour = this.showEndHour
      }
    },

    checkScrollToHour() {
      if(this.autoscrollHour != -1) {
        this.scrollToHour() 
      }  
    },

    scrollToHour(now=false) {
      let nowHour = now ? this.currentDate.hours() : this.autoscrollHour
      let nowMinute = now ? this.currentDate.minutes() : 0

      this.autoscrollHour = now ? nowHour : this.autoscrollHour

      let topCurrentHour = document.querySelectorAll(`.calendar-wrapper .column.hours .row.hour-${nowHour}`) && document.querySelectorAll(`.calendar-wrapper .column.hours .row.hour-${nowHour}`)[0] 
                            ? document.querySelectorAll(`.calendar-wrapper .column.hours .row.hour-${nowHour}`)[0].offsetTop
                            : 0
      let heightCurrentHour = document.querySelectorAll(`.calendar-wrapper .column.hours .row.hour-${nowHour}`) && document.querySelectorAll(`.calendar-wrapper .column.hours .row.hour-${nowHour}`)[0]
                            ? document.querySelectorAll(`.calendar-wrapper .column.hours .row.hour-${nowHour}`)[0].offsetHeight
                            : 0

      this.positionCursorHour = now ? topCurrentHour + (heightCurrentHour / 60) * nowMinute : this.positionCursorHour

      if(document.querySelectorAll('.calendar-wrapper #calendar-content') && document.querySelectorAll('.calendar-wrapper #calendar-content')[0])
        document.querySelectorAll('.calendar-wrapper #calendar-content')[0].scrollTo({
          top: topCurrentHour + (heightCurrentHour / 60) * nowMinute,
          behavior: 'smooth',
        })
    },

    async validatePostEvent(body){  
      this.closeSidebar()
      this.$emit('validate', body)
    },

    deleteScheduledEvent(news){
      this.$emit('deleteScheduled', news)
      this.closeSidebar()
    },

    removeDrafts(postId){
      this.$emit('removeDrafts', postId)
      this.closeSidebar()
    },

    addPostEvent(clean=false, day=null, hour=null, minute=null, deleteSlot=false, slotDate=null, slotBot=null){
      this.showSidebar = false
      if(slotDate){
        this.$emit('add', clean, day, hour, minute, deleteSlot, slotDate, slotBot)
      }
      else if(day.hours(hour).unix() > moment().minutes(0).seconds(0).unix())
        this.$emit('add', clean, day, hour)
    },

    excludeNewsEvent(bot,post){
      this.$emit('excludeNews', bot, post)
    },

    async deleteSlotEvent(bot){
      console.log('deleteSlotEvent')
      this.$emit('reload', this.startDate, this.endDate)

      this.showSidebar = false      
    },

    openLoader(bool){
      this.$emit('openLoader', bool)
    },

    async validateScheduledPostEvent(body, all=false){  

      console.log('validatePost', body)
      const user = JSON.parse(localStorage.user)
      await this.validateWaitingPost(body, {
        name: `${user.firstname} ${user.lastname}`, 
        email: user.email,
        date: moment().format()
      }, all)
      .then(() => {
        setTimeout(() => {this.$emit('reload', this.startDate, this.endDate)}, 500)
      })
      .then(this.closeSidebar)
    },

    async addComment(post, message, mediasUpload, all=false) {
      console.log('addComment', post, message, mediasUpload, all)
      const user = JSON.parse(localStorage.user)
      await this.addCommentPost(post, {
        name: `${user.firstname} ${user.lastname}`, 
        email: user.email,
        date: moment().format(),
        message,
        mediasUpload}, all)
      .then(() => {
        setTimeout(() => {this.$emit('reload', this.startDate, this.endDate)}, 500)
      })
      .then(this.closeSidebar)
    },
  
  },

  computed: {

    getUserRole() {
      const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
      if(!user) return null
      if(user.admin)
        return 'Admin'
      else
        return user.role && user.role.length
                    ? user.role[0]
                    : 'Editor'
      
    },

    activeLog() {
      const logUser = [
        //sandbox
        'aiminne+free1@mashup-web.com',
        //prod
        "aiminne@mashup-web.com",
        "matthieu@mashup-web.com",
        "vdiakov@reworldmedia.com",
        "ldesmarecaux@reworldmedia.com",
        'ajeunet@reworldmedia.com',
        'mashup.md@reworldmedia.com',
        "a.samari@sfmd.fr",
        "egrasset@reworldmedia.com"
      ]
      const logAccount = [
        //prod
        "c93f4d0a-d1eb-4561-8071-bd4ef9fdf72a", //rcf
        "da502f9e-c999-4896-baed-4e1c4110409a", //wmki
        "d2e5ed17-eaf3-4ba0-a2ba-9e1f95757776", //fcr
      ]
      const user = JSON.parse(localStorage.user)
      return logUser.includes(user.email) || logAccount.includes(user.account)
    },

    showCursor() {
      return this.currentDate.isBefore(this.endDate) && this.currentDate.isAfter(this.startDate)
    },

    pageWithAutoPost() {
      return this.bots.length && this.bots.find(b => b.frequency != 0)
    }
  },

  watch: {   
    
    gridData: {
      handler(val, oldVal){
        this.closeSidebar()

        if(this.activeAutoScroll){
          setTimeout(this.scrollToHour(true), 250)
        }
        
        this.showStartHour = 23
        this.showEndHour = 0
        for(const cal in this.gridData.calendar) {
          for(let h=0; h<=23; h++){
            if(this.gridData.calendar[cal].slots[h].find(p => p.status != 'slot') 
                  && h < this.showStartHour) 
              this.showStartHour = h
          }
    
          for(let h=23; h>=0; h--){
            if(this.gridData.calendar[cal].slots[h].find(p => p.status != 'slot') 
                  && h > this.showEndHour) 
              this.showEndHour = h
          }
        }
        if(this.showStartHour == 23 && this.showEndHour == 0) {
          this.showStartHour = 0
          this.showEndHour = 23
        }
      },
      deep: true
    },

    showSidebar() {
      if(!this.showSidebar)
        this.post = {
          id: null,
          title: null,
          url: null,
          posted_date: null,
          scheduled_date: null,
          preview_date: null,
          date: null,
          status: null, // 0 preview - 1 scheduled - 2 posted
          page: null,
          enclosure: null,
          stats: null
        }
    },

    isDeleteSlot: {
      async handler(val, oldVal){
        if(val == false && oldVal == true){
          await this.deleteSlot(this.slotDate, this.slotBot)
          this.$emit('resetDeleteSot')
        }
      },
      deep: true
    },

  }
}    
</script>